import React from 'react';
import PropTypes from 'prop-types';

function ErrorMessage(props) {
  if (props.error) {
    return (
      <div className="error-message mb-3 d-flex align-items-center justify-content-center shadow-none" elevation={2}>
        <p className="mb-0">
          {props.error}
        </p>
      </div>
    );
  } else {
    return null;
  }
}

ErrorMessage.propTypes = {
  error: PropTypes.string,
};

export default ErrorMessage;
